<template>
  <NavbarFive class="home_one" />
  <ResponsiveNavbarFive class="home_one" />
  <PageBanner
    pageTitle="Blog Details Right Sidebar"
    mainTitle="Blog Details Right Sidebar"
  />
  <BlogDetailsRightSidebar />
  <DownloadTheApp />
  <MainFooter />
</template>

<script lang="ts">
import { defineComponent } from "vue";
import NavbarFive from "../components/Layouts/NavbarFive.vue";
import ResponsiveNavbarFive from "../components/Layouts/ResponsiveNavbarFive.vue";
import PageBanner from "../components/Common/PageBanner.vue";
import BlogDetailsRightSidebar from "../components/BlogDetailsRightSidebar/BlogDetailsRightSidebar.vue";
import DownloadTheApp from "../components/Common/DownloadTheApp.vue";
import MainFooter from "../components/Layouts/MainFooter.vue";

export default defineComponent({
  name: "BlogDetailsRightSidebarPage",
  components: {
    NavbarFive,
    ResponsiveNavbarFive,
    PageBanner,
    BlogDetailsRightSidebar,
    DownloadTheApp,
    MainFooter,
  },
});
</script>